export default function SecondSectionPickleball() {
  return (
    <section className="">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            NextLoop <span className="text-[#92abc4]">Pickleball</span>
            <br />Coming Soon!
          </h2>
          <p className="text-gray-500 mt-4 max-w-lg leading-relaxed">
            We're currently building something exciting! Our pickleball courts
            will soon be ready for public bookings and community events. Stay
            tuned — you’ll be able to play, connect, and compete right here.
          </p>

          <button className="mt-6 border border-slate-900 px-6 py-3 rounded-full bg-slate-100 text-slate-900 cursor-not-allowed">
            Coming Soon
          </button>
        </div>

        {/* Right */}
        <div className="relative rounded-3xl w-full lg:w-3/4 overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1618551763300-dc7eb8ce3560?q=80&w=1075&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Pickleball court"
            className="w-full h-auto object-cover"
          />

        </div>
      </div>
    </section>
  );
}
